import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';

var PinCodeLabelUtil = function PinCodeLabelUtil(pinCodeLength) {
  var sixDigitCodeLabels = {
    info: ['MPLIB_WIZARD_CREATE_PINCODE_INTRODUCTION_6DIGIT', 'MPLIB_WIZARD_CREATE_PINCODE_NOTE', 'MPLIB_WIZARD_CREATE_PINCODE_ENTER_CODE_6DIGIT'],
    placeholder: 'MPLIB_WIZARD_CREATE_PINCODE_ENTER_CODE_PLACEHOLDER_6DIGIT'
  };
  var fourDigitCodeLabels = {
    info: ['MPLIB_WIZARD_CREATE_PINCODE_INTRODUCTION_4DIGIT'],
    placeholder: 'MPLIB_WIZARD_CREATE_PINCODE_ENTER_CODE_PLACEHOLDER'
  };
  return pinCodeLength > 4 ? sixDigitCodeLabels : fourDigitCodeLabels;
};
var usePinCodeUtility = function usePinCodeUtility(pinCodeLength) {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    displayText = _useState2[0],
    setDisplayText = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    secondaryDisplayText = _useState4[0],
    setSecondaryDisplayText = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    code = _useState6[0],
    setCode = _useState6[1];
  var isNumeric = function isNumeric(value) {
    return /^[0-9]+$/.test(value);
  };
  var isValidCode = isNumeric(code) && code.length === pinCodeLength;
  var validateInput = function validateInput(value) {
    if (isNumeric(value) || !value) {
      setCode(value);
      setDisplayText('');
    }
  };
  return {
    displayText: displayText,
    code: code,
    setCode: setCode,
    isValidCode: isValidCode,
    validateInput: validateInput,
    setDisplayText: setDisplayText,
    setSecondaryDisplayText: setSecondaryDisplayText,
    secondaryDisplayText: secondaryDisplayText
  };
};

export { PinCodeLabelUtil, usePinCodeUtility as default };
